module.exports = __webpack_public_path__ + "img/71.f9ed88df.jpg";